export const applicationList = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch('/ai-web/diagnosis/applicationList', init).then(
    res => res.json(),
    error => console.error(error)
  );
};

export const nbReviewList = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch('/ai-web/diagnosis/nbReviewList', init).then(
    res => res.json(),
    error => console.error(error)
  );
};

export const reviewNB = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch('/ai-web/diagnosis/reviewNb', init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//新增报告申请
export const saveApplication = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/diagnosis/saveApplication`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//修改申请单
export const updateApplication = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  let url = `/ai-web/diagnosis/updateApplication`;
  return fetch(url, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//查看申请单详情
export const applicationInfo = id => {
  const init = { method: 'GET' };
  return fetch(
    `/ai-web/diagnosis/applicationInfo?applicationId=${id}`,
    init
  ).then(res => res.json(), error => console.error(error));
};

//申请单作废/恢复
export const updateValid = (id, state) => {
  const init = { method: 'GET' };
  return fetch(
    `/ai-web/diagnosis/updateValid?diagId=${id}&validFlag=${state}`,
    init
  ).then(res => res.json(), error => console.error(error));
};

//填写报告
export const writeReport = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/diagnosis/writeReport?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//暂存报告/提交报告
export const saveReport = post => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(post),
  };
  return fetch(`/ai-web/diagnosis/saveReport`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//修改医生审核状态
export const setDoctorReviewStatus = (id, status) => {
  const init = { method: 'GET' };
  return fetch(
    `/ai-web/fromDr/setDoctorReviewStatus?dicomDrId=${id}&status=${status}`,
    init
  ).then(res => res.json(), error => console.error(error));
};

//修改医生审核状态（合并后）
export const setDoctorReviewStatus4Study = (id, status) => {
  const init = { method: 'GET' };
  return fetch(
    `/ai-web/fromDr/setDoctorReviewStatus4Study?studyDrId=${id}&status=${status}`,
    init
  ).then(res => res.json(), error => console.error(error));
};

//立即申请
export const apply = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/diagnosis/apply?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//获取可以合并的片子列表
export const applyRelatedDrList = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/diagnosis/applyRelatedDrList?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

// 审核报告
export const verifyReport = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/diagnosis/verifyReport?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

// 提交审核
export const saveVerify = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/diagnosis/saveVerify`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//暂存审核
export const tempSaveVerify = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/diagnosis/tempSaveVerify`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//操作记录
export const operationRecord = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/diagnosis/operationRecord?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//预览报告
export const reportInfo = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/diagnosis/reportInfo?applicationId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//拒绝原因列表
export const refuseReportReason = () => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/dict/refuseReportReason`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//查看拒绝原因
export const diagnosisRefuseReportReason = id => {
  const init = { method: 'GET' };
  return fetch(
    `/ai-web/diagnosis/refuseReportReason?applicationId=${id}`,
    init
  ).then(res => res.json(), error => console.error(error));
};

//拒绝报告
export const refuseReport = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/diagnosis/refuseReport`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//知识库树查询
export const knowledgeTree = (flag, id, text) => {
  const init = { method: 'GET' };
  let url = `/ai-web/knowledge/tree`;
  if (flag !== undefined) {
    url += `?privateFlag=${flag}`;
    if (id) url += `&rootId=${id}`;
    if (text) url += `&keyword=${text}`;
  } else {
    if (id) url += `?rootId=${id}`;
    if (text) url += `&keyword=${text}`;
  }

  return fetch(url, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//知识库查询-列表
export const knowledgeList = (flag, text, page, size) => {
  const init = { method: 'GET' };
  let url = `/ai-web/knowledge/pageSelect?privateFlag=${flag}`;
  if (text) url += `&keyword=${text}`;
  if (page && size) url += `&pageSize=${size}&pageNum=${page}`;
  return fetch(url, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//知识库根据ID查询详情
export const knowledgeDelectById = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/knowledge/selectById?id=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//放弃报告
export const quitReport = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/diagnosis/quitReport?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//放弃审核
export const quitVerify = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/diagnosis/quitVerify?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//历史信息
export const reportHis = (reportId, diagId) => {
  const init = { method: 'GET' };
  return fetch(
    `/ai-web/diagnosis/reportHis?reportId=${reportId}&diagId=${diagId}`,
    init
  ).then(res => res.json(), error => console.error(error));
};

//新增知识项
export const saveKnowledge = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/knowledge/save`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//修改知识项
export const updateKnowledge = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/knowledge/update`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//删除知识项
export const deleteKnowledge = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/knowledge/delete?id=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//打印报告
export const printReport = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/diagnosis/printReport?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//获取体位
export const positionList = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/dict/${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//统计不同状态的记录数
export const stateCount = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/diagnosis/stateCount`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//点击继续审核
export const continueVerify = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/diagnosis/continueVerify?reportId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//点击继续填写
export const continueReport = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/diagnosis/continueReport?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//统计分析-远程诊断报告列表
export const diagStatistics = data => {
  const init = { method: 'GET' };
  let url = `/ai-web/diagStatistics/listByPage?`;
  let params = [];
  if (data.startTime) params.push(`startTime=${data.startTime}`);
  if (data.endTime) params.push(`endTime=${data.endTime}`);
  if (data.institutionId) params.push(`institutionId=${data.institutionId}`);
  if (data.pageSize) params.push(`pageSize=${data.pageSize}`);
  if (data.pageNum) params.push(`pageNum=${data.pageNum}`);
  if (data.verifyUserId) params.push(`verifyUserId=${data.verifyUserId}`);
  if (data.reportUserId) params.push(`reportUserId=${data.reportUserId}`);
  return fetch(url + params.join('&'), init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//撤销报告
export const undoReport = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/diagnosis/undoReport?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//撤销审核
export const undoVerify = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/diagnosis/undoVerify?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//打印后报告纠错
export const undoPrintReport = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/diagnosis/undoPrintReport?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//同姓名历史诊断信息
export const oneNameDiagList = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/diagnosis/oneNameDiagList?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//远程诊断报告医生列表
export const reportDoctorList = (name = '') => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/diagnosis/reportDoctorList?name=${name}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//远程诊断报告审核医生列表
export const reviewDoctorList = (name = '') => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/diagnosis/reviewDoctorList?name=${name}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//打印报告前校验是否可以打印
export const permitPrintReport = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/diagnosis/permitPrintReport?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//AI自动报告列表
export const aiReportList = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/aiReport/list`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

export const getToken = () => {
  const init = { method: 'GET' };
  return fetch(`/ai-web/auth/getToken`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//清空影像所见和诊断建议埋点
export const rmAiTxt = data => {
  const init = { method: 'GET' };
  let url = `/ai-web/aiReport/rmAiTxt?aiReportId=${data.id}&types=${data.types}`;
  if (data.report) url += `&report=${data.report}`;
  return fetch(url, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//审核时退回重写
export const refuseReView = id => {
  let url = `/ai-web/diagnosis/refuseReView`;
  const post = { diagId: id };
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(post),
  };
  return fetch(url, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//随访记录
export const oneNameDicomList = id => {
  let url = `/ai-web/diagnosis/oneNameDicomList?diagId=${id}`;
  const init = { method: 'GET' };
  return fetch(url, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//疑难转诊
export const toVerify2 = id => {
  let url = `/ai-web/diagnosis/toVerify2?diagId=${id}`;
  const init = { method: 'GET' };
  return fetch(url, init).then(
    res => res.json(),
    error => console.error(error)
  );
};
//数据看板-远程诊断报告分析
export const serviceCountList = (beginTime, endTime) => {
  let url = `/ai-web/report/service/count-list?beginTime=${beginTime}&endTime=${endTime}`;
  const init = { method: 'GET' };
  return fetch(url, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

export const tbReportPreview = token => {
  let url = `/ai-web/diagnosis/report/preview?token=${token}`;
  const init = { method: 'GET' };
  return fetch(url, init).then(
    res => res.json(),
    error => console.error(error)
  );
};
